import { useEffect, useState } from 'react';
import type { InstagramFeed } from '@peles/shared';
import { getInstagramFeed } from '../api/publicSite';

export interface UseInstagramFeedResult {
  feed: InstagramFeed | null;
  loading: boolean;
}

/**
 * Loads the public Instagram feed once on mount. Errors are swallowed so the
 * landing page degrades gracefully (the section hides itself when there is no
 * feed and no profile URL to link to).
 */
export function useInstagramFeed(): UseInstagramFeedResult {
  const [feed, setFeed] = useState<InstagramFeed | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    getInstagramFeed()
      .then((result) => {
        if (active) setFeed(result);
      })
      .catch(() => {
        if (active) setFeed(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return { feed, loading };
}
